import { TextareaField } from "components/TextareaField";
import { useFormik } from "formik";
import { head, replace } from "lodash";
import { InputField } from "components/InputField";
import React, { useEffect, useMemo, useState } from "react";
import { Link, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import AlertDialog from "../../../components/Dialog";
import EditAccountBillingType from "../FinancialSettingPage/AccountBillingType/EditAccountBillingType";
import BillingTypesBody from "../FinancialSettingPage/AccountBillingType/billingTypesBody";
import AccountReceivable from "../FinancialSettingPage/AccountReceivable/AccountReceivable.js";
import EditAccountReceivalbe from "../FinancialSettingPage/AccountReceivable/EditAccountReceivable";
import AddNewBankAccount from "../FinancialSettingPage/BankAccounts/AddNewBankAccount";
import BankAccountCheckBox from "../FinancialSettingPage/BankAccounts/BankAccountBody";
import ChargeTypesBody from "../FinancialSettingPage/ChargeTypes/ChargeTypesBody";
import NewEditChargeTypes from "../FinancialSettingPage/ChargeTypes/NewEditChargeTypes";
import LedgerAccountsView from "../FinancialSettingPage/LedgerAccounts/LedgerAccountsView";
import NewLedgerAccounts from "../FinancialSettingPage/LedgerAccounts/NewLedgerAccounts";
import ConvenienceFeeAmount from "../FinancialSettingPage/PaymentsTypes/ConvenienceFeeAmount";
import EditPaymentType from "../FinancialSettingPage/PaymentsTypes/EditPaymentType";
import LedgerList from "../FinancialSettingPage/PaymentsTypes/LedgerList";
import TypeCheckBoxes from "../FinancialSettingPage/PaymentsTypes/PaymentCheckBox";
import PaymentGatewaySelection from "../FinancialSettingPage/PaymentsTypes/PaymentGatewaySelection";
import PaymentGateways from "../FinancialSettingPage/ProviderInfo/index";
import EditReversalTypes from "../FinancialSettingPage/ReversalTypes/EditReversalTypes";
import ReversalCheckBoxes from "../FinancialSettingPage/ReversalTypes/ReversalCheckBoxes";
import AccountTypesEdit from "../MembersSettingPage/AccountTypesEdit/AccountTypesEdit";
import AccountsTypesView from "../MembersSettingPage/AccountsTypesView/AccountsTypesView";
import DropDownOptions from "../MembersSettingPage/DropDownOptions/DropDownOptions";

const ComponentHeading = ({
  type,
  heading,
  addNew,
  disable,
  setDaisableAddNew,
  setDisable,
  edit,
  setEdit,
  chargeTypeTree,
  setAddPath,
  ledgerSubLedgerData,
  updateFunc,
  formik,
  createFunc,
  ledgerNameList,
  deleteFunc,
  addPath,
  setAddNew,
  disableAddNew,
  accounts,
  showNameChangeConfirm,
  setShowNameChangeConfirm,
  onConfirmNameChange,
}) => {
  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleDelete = () => {
    deleteFunc();
    setOpenDisableAlert(false);
  };
  const nestedTypesRoutes = [
    {
      path: "/financial-setting/members/account-types/edit",
      title: "Account Categories",
      page: (
        <AccountTypesEdit
          type={type}
          edit={edit}
          updateFunc={updateFunc}
          formik={formik}
          addNew={addNew}
          createFunc={createFunc}
          addPath={addPath}
          setEdit={setEdit}
          setDaisableAddNew={setDaisableAddNew}
          setDisable={setDisable}
          setAddNew={setAddNew}
          disable={disable}
        />
      ),
    },
    {
      path: "/financial-setting/reversal-types/edit",
      title: "Reversal Types",
      page: (
        <EditReversalTypes
          type={type}
          edit={edit}
          updateFunc={updateFunc}
          formik={formik}
          addNew={addNew}
          createFunc={createFunc}
          addPath={addPath}
          disable={disable}
        />
      ),
    },
    {
      path: "/financial-setting/account-billing-types/edit",
      title: "Account Billing Type",
      page: (
        <EditAccountBillingType
          formik={formik}
          type={type}
          addNew={addNew}
          edit={edit}
          updateFunc={updateFunc}
          createFunc={createFunc}
          setDaisableAddNew={setDaisableAddNew}
          setEdit={setEdit}
          setAddNew={setAddNew}
          setDisable={setDisable}
          disable={disable}
        />
      ),
    },
    {
      path: "/financial-setting/payment-types/edit",
      title: "Payment Types",
      page: (
        <EditPaymentType
          formik={formik}
          type={type}
          addNew={addNew}
          edit={edit}
          updateFunc={updateFunc}
          createFunc={createFunc}
          setDaisableAddNew={setDaisableAddNew}
          setEdit={setEdit}
          setAddNew={setAddNew}
          setDisable={setDisable}
        />
      ),
    },
    {
      path: "/financial-setting/bank-accounts/edit",
      title: "Bank Accounts",
      page: (
        <AddNewBankAccount
          addNew={addNew}
          formik={formik}
          edit={edit}
          type={type}
          updateFunc={updateFunc}
          createFunc={createFunc}
          setDaisableAddNew={setDaisableAddNew}
          setEdit={setEdit}
          setAddNew={setAddNew}
          setDisable={setDisable}
          disable={disable}
          disableAddNew={disableAddNew}
        />
      ),
    },
    {
      path: "/charge-types/edit",
      title: "Charge Types",
      page: (
        <NewEditChargeTypes type={type} addNew={addNew} disable={disable} />
      ),
    },
    {
      path: "/financial-setting/ledger-accounts/edit",
      title: "Ledger Accounts",
      page: (
        <NewLedgerAccounts
          edit={edit}
          formik={formik}
          type={type}
          addNew={addNew}
          updateFunc={updateFunc}
          ledgerNameList={ledgerNameList}
          createFunc={createFunc}
          disable={disable}
          addPath={addPath}
          showNameChangeConfirm={showNameChangeConfirm}
          setShowNameChangeConfirm={setShowNameChangeConfirm}
          onConfirmNameChange={onConfirmNameChange}
          ledgerSubLedgerData={ledgerSubLedgerData}
        />
      ),
    },
    {
      path: "/financial-setting/accounts-receivable/edit",
      title: "Accounts Receivable",
      page: (
        <EditAccountReceivalbe
          formik={formik}
          type={type}
          addNew={addNew}
          edit={edit}
          updateFunc={updateFunc}
          createFunc={createFunc}
          setDaisableAddNew={setDaisableAddNew}
          setEdit={setEdit}
          setAddNew={setAddNew}
          setDisable={setDisable}
        />
      ),
    },
  ];
  const filteredNestedRoutes = nestedTypesRoutes.find(
    (item) => item.title === heading
  );

  useEffect(() => {
    setAddPath(filteredNestedRoutes.path);
  }, []);

  const { push } = useHistory();
  const editType = (e) => {
    e.preventDefault();
    setEdit(true);
    setDaisableAddNew(true);
    setDisable(true);
    push({
      pathname: filteredNestedRoutes.path,
    });
  };

  let selectedAccount = accounts?.find((item) => item?.ar_name === type);

  return (
    <div className="bg-white h-100 position-relative">
      {(heading === "Ledger Accounts" || heading === "Charge Types") &&
        (addNew === true || edit === true) ? (
        ""
      ) : (
        <div className=" heading-main heading-mobile-view">
          <div className=" setting-head set-mobile">
            <h2
              title={
                edit === true || addNew === true
                  ? ""
                  : type?.charAt(0)?.toUpperCase() +
                  type?.slice(1)?.replace("-", " ") || type
              }
            >
              {edit === true || addNew === true
                ? ""
                : type?.length > 20
                  ? type?.charAt(0)?.toUpperCase() +
                  type?.slice(1)?.replace("-", " ").substring(0, 20) +
                  "..."
                  : type}
            </h2>
            {selectedAccount ? (
              heading === "Ledger Accounts" ||
                heading === "Charge Types" ||
                addNew === true ||
                edit === true ? (
                ""
              ) : (
                <p>{selectedAccount?.ar_id}</p>
              )
            ) : (
              ""
            )}
          </div>
          <div className="mt-3 setting-actions">
            {chargeTypeTree ? (
              <a style={{ color: "#2555EF" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="17"
                  viewBox="0 0 15 17"
                  fill="none"
                >
                  <path
                    d="M1.95833 0.583008C1.09299 0.583008 0.375 1.301 0.375 2.16634V14.833C0.375 15.6983 1.09299 16.4163 1.95833 16.4163H13.0417C13.907 16.4163 14.625 15.6983 14.625 14.833V2.16634C14.625 1.301 13.907 0.583008 13.0417 0.583008H1.95833ZM1.95833 2.16634H13.0417V5.33301H1.95833V2.16634ZM5.91667 2.95801V4.54134H9.08333V2.95801H5.91667ZM1.95833 6.91634H13.0417V10.083H1.95833V6.91634ZM5.91667 7.70801V9.29134H9.08333V7.70801H5.91667ZM1.95833 11.6663H13.0417V14.833H1.95833V11.6663ZM5.91667 12.458V14.0413H9.08333V12.458H5.91667Z"
                    fill="#2555EF"
                  />
                </svg>
                Archive
              </a>
            ) : (
              ""
            )}
            {addNew === true || edit === true ? (
              ""
            ) : (
              <>
                {type === "check" ||
                  type === "cash" ||
                  type === "credit card" ||
                  type === "credit on account" ||
                  type === "ach" ? (
                  ""
                ) : (
                  <a
                    style={{ color: "#F1585E" }}
                    onClick={() => setOpenDisableAlert(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                      <path
                        fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                    Delete
                  </a>
                )}
                <AlertDialog
                  open={openDisableAlert}
                  handleClose={handleCloseDialog}
                  onDecline={() => {
                    setOpenDisableAlert(false);
                  }}
                  onAccept={handleDelete}
                  title={"Are you sure?"}
                />
              </>
            )}
            {!disable && (
              <Link style={{ color: "#2555EF" }} onClick={editType}>
                {
                  // type === "check" ||
                  // type === "cash" ||
                  // type === "credit card" ||
                  // type === "credit on account" ? (
                  //   ""
                  // ) : (
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                      />
                    </svg>
                    <span> Edit</span>
                  </span>
                  // )
                }
              </Link>
            )}
          </div>
        </div>
      )}
      <Route
        exact={true}
        path={filteredNestedRoutes.path}
        children={filteredNestedRoutes.page}
      />
      <Route exact={false} path="/financial-setting/members/account-types/view">
        <AccountsTypesView edit={edit} formik={formik} addNew={addNew} />
      </Route>
      <Route exact={false} path="/financial-setting/reversal-types/view">
        <ReversalCheckBoxes edit={edit} formik={formik} addNew={addNew} />
      </Route>
      <Route exact={false} path="/financial-setting/account-billing-types/view">
        <BillingTypesBody type={type} formik={formik} />
      </Route>
      <Route exact={false} path="/financial-setting/payment-types/view">
        {(formik.values?.payement_type_new === "ach" || formik.values?.payement_type_new === "credit card") && (
          <PaymentGatewaySelection
            formik={formik}
            view={true}
            className="payment_settings_gateway-view"
          />
        )}
        <TypeCheckBoxes edit={edit} formik={formik} addNew={addNew} />
        {formik.values?.coverConvenienceFee && (
          <div className="d-flex p-5 flex-column convenience-wrapper convenience-wrapper-view">
               {formik.values?.optionalConvenienceFee && (

              <div className="d-flex flex-column convenience-wrapper">

                <InputField

                  formik={formik}

                  name={`optionalConvenienceFeeInfo.optionalConvenienceFeeMessage`}

                  title="Message"

                  placeholder="Enter message"

                  mandatory={true}

                  disabled

                  value={

                    formik.values?.optionalConvenienceFeeInfo

                      ?.optionalConvenienceFeeMessage

                  }

                  onChange={(e) => {

                    formik.setFieldValue(

                      `optionalConvenienceFeeInfo.optionalConvenienceFeeMessage`,

                      e.target.value

                    );

                  }}

                  multiline

                  rows={3}

                  style={{ width: "100%" }}

                />

              </div>

            )}
            <ConvenienceFeeAmount formik={formik} type="view" />
            <LedgerList formik={formik} type="view" />
          </div>
        )}
      </Route>
      <Route exact={false} path="/financial-setting/bank-accounts/view">
        <BankAccountCheckBox formik={formik} />
      </Route>
      <Route exact={false} path="/charge-types/view">
        <ChargeTypesBody type={type} />
      </Route>
      <Route exact={false} path="/financial-setting/ledger-accounts/view">
        <LedgerAccountsView
          ledgerSubLedgerData={ledgerSubLedgerData}
          edit={edit}
          formik={formik}
        />
      </Route>
      <Route exact={false} path="/financial-setting/provider-info/view">
        <PaymentGateways />
      </Route>
      <Route exact={false} path="/financial-setting/accounts-receivable/view">
        {/* <TypeCheckBoxes edit={edit} formik={formik} addNew={addNew} /> */}
      </Route>
      <Route exact={false} path="/financial-setting/members/dropdown-options">
        <DropDownOptions />
      </Route>
    </div>
  );
};

export default ComponentHeading;
